import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from '@mui/material';
import { fr } from 'date-fns/locale';
import { format } from 'date-fns';

// Données de démonstration pour les dates de chargement
const scheduleData = [
  {
    id: 1,
    destination: 'Abidjan',
    origin: 'Paris',
    containerType: '40 HC',
    loadingDate: '2025-05-01',
    departureDate: '2025-05-03',
    arrivalDate: '2025-05-25',
  },
  {
    id: 2,
    destination: 'Abidjan',
    origin: 'Paris',
    containerType: '20 DC',
    loadingDate: '2025-05-10',
    departureDate: '2025-05-12',
    arrivalDate: '2025-06-03',
  },
  {
    id: 3,
    destination: 'Paris',
    origin: 'Abidjan',
    containerType: '40 HC',
    loadingDate: '2025-05-15',
    departureDate: '2025-05-17',
    arrivalDate: '2025-06-08',
  },
  {
    id: 4,
    destination: 'Abidjan',
    origin: 'Paris',
    containerType: '40 HC',
    loadingDate: '2025-05-20',
    departureDate: '2025-05-22',
    arrivalDate: '2025-06-13',
  },
  {
    id: 5,
    destination: 'Paris',
    origin: 'Abidjan',
    containerType: '20 DC',
    loadingDate: '2025-05-25',
    departureDate: '2025-05-27',
    arrivalDate: '2025-06-18',
  },
  {
    id: 6,
    destination: 'Abidjan',
    origin: 'Paris',
    containerType: '40 HC',
    loadingDate: '2025-06-01',
    departureDate: '2025-06-03',
    arrivalDate: '2025-06-25',
  },
  {
    id: 7,
    destination: 'Paris',
    origin: 'Abidjan',
    containerType: '40 HC',
    loadingDate: '2025-06-05',
    departureDate: '2025-06-07',
    arrivalDate: '2025-06-29',
  },
  {
    id: 8,
    destination: 'Abidjan',
    origin: 'Paris',
    containerType: '20 DC',
    loadingDate: '2025-06-10',
    departureDate: '2025-06-12',
    arrivalDate: '2025-07-04',
  },
  {
    id: 9,
    destination: 'Paris',
    origin: 'Abidjan',
    containerType: '40 HC',
    loadingDate: '2025-06-15',
    departureDate: '2025-06-17',
    arrivalDate: '2025-07-09',
  },
];

// Configuration des colonnes
const columns = [
  {
    id: 'origin',
    label: 'Départ',
    minWidth: 130,
  },
  {
    id: 'destination',
    label: 'Destination',
    minWidth: 130,
  },
  {
    id: 'containerType',
    label: 'Type Conteneur',
    minWidth: 150,
  },
  {
    id: 'loadingDate',
    label: 'Date de Chargement',
    minWidth: 180,
    format: (value) => format(new Date(value), 'dd MMMM yyyy', { locale: fr }),
  },
  {
    id: 'departureDate',
    label: 'Date de Départ',
    minWidth: 180,
    format: (value) => format(new Date(value), 'dd MMMM yyyy', { locale: fr }),
  },
  {
    id: 'arrivalDate',
    label: "Date d'Arrivée",
    minWidth: 180,
    format: (value) => format(new Date(value), 'dd MMMM yyyy', { locale: fr }),
  },
];

const Schedule = () => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          py: 8,
          mb: 6,
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h3" gutterBottom>
            Calendrier des Chargements
          </Typography>
          <Typography variant="h5">
            Consultez les dates de chargement et l'espace disponible dans nos conteneurs
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg">
        <Paper sx={{ p: 4, mb: 4 }}>
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      sx={{
                        backgroundColor: 'primary.light',
                        color: 'primary.contrastText',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {scheduleData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.format ? column.format(value) : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={scheduleData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Lignes par page"
          />
        </Paper>
      </Container>
    </Box>
  );
};

export default Schedule;
